// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14n60","colMin":"styles_colMin__4m4E1"};